"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = void 0;

var _react = require("@chakra-ui/react");

var _FaChevronLeft = require("@react-icons/all-files/fa/FaChevronLeft");

var _FaChevronRight = require("@react-icons/all-files/fa/FaChevronRight");

var _react2 = _interopRequireDefault(require("react"));

var _useDragScroll2 = _interopRequireDefault(require("./useDragScroll"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children", "elementProps", "disableControls", "captureHorizontalScroll"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var NavigateButton = function NavigateButton(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.IconButton, {
    "aria-label": "Slide to ".concat(props.direction),
    position: "absolute",
    zIndex: 999999999,
    display: {
      base: 'none',
      lg: 'block'
    },
    boxSize: "16",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    _hover: {
      boxShadow: '0px 0px 10px rgba(0,0,0,0.1)'
    },
    className: "button",
    isRound: true,
    onClick: function onClick() {
      return props.scroll(props.direction);
    },
    left: props.direction === 'left' ? 5 : undefined,
    right: props.direction === 'right' ? 5 : undefined,
    bg: (0, _react.useColorModeValue)('blackAlpha.600', 'blackAlpha.900'),
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
      color: (0, _react.useColorModeValue)('gray.200', 'gray.200'),
      boxSize: "8",
      as: props.direction === 'left' ? _FaChevronLeft.FaChevronLeft : _FaChevronRight.FaChevronRight
    })
  });
};

var Slider = function Slider(_ref) {
  var children = _ref.children,
      elementProps = _ref.elementProps,
      disableControls = _ref.disableControls,
      captureHorizontalScroll = _ref.captureHorizontalScroll,
      containerProps = _objectWithoutProperties(_ref, _excluded);

  var ref = _react2["default"].useRef(null);

  var _useDragScroll = (0, _useDragScroll2["default"])({
    sliderRef: ref,
    reliants: [],
    captureHorizontalScroll: captureHorizontalScroll
  }),
      scroll = _useDragScroll.scroll,
      canScrollLeft = _useDragScroll.canScrollLeft,
      canScrollRight = _useDragScroll.canScrollRight;

  var styledChildren = _react2["default"].Children.map(children, function (child, index) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({
      boxSize: 'fit-content'
    }, elementProps), {}, {
      flexShrink: 0,
      children: child
    }), index);
  });

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Box, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Flex, {
      pos: "relative",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.HStack, _objectSpread(_objectSpread({
        ref: ref,
        overflowX: "scroll"
      }, containerProps), {}, {
        children: styledChildren
      })), !disableControls && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [canScrollLeft && /*#__PURE__*/(0, _jsxRuntime.jsx)(NavigateButton, {
          direction: "left",
          scroll: scroll
        }), canScrollRight && /*#__PURE__*/(0, _jsxRuntime.jsx)(NavigateButton, {
          direction: "right",
          scroll: scroll
        })]
      })]
    })
  });
};

exports.Slider = Slider;